import {
	//deviceType,
	primaryInput,
	//supportsPointerEvents,
	//supportsTouchEvents,
	//supportsPassiveEvents,
} from 'detect-it';

(function() {
	const html = document.documentElement;
	const inputClass = primaryInput === 'touch' ? 'is-touch' : 'has-pointer';
	html.classList.remove('no-js');
	html.classList.add('js');
	html.classList.add(inputClass);
})();